export interface Portal {
  name: string;
  path: string;
  icon: string;
}

export const PORTALS: Portal[] = [
  {
    name: 'Quản trị nhân lực',
    path: '/hr',
    icon: '/icons/portal-hr.png',
  },
  {
    name: 'Quản trị tài chính',
    path: '/finance',
    icon: '/icons/portal-salary.png',
  },
  {
    name: 'Quản lý công việc',
    path: '/task',
    icon: '/icons/portal-task.png',
  },
];

export const getCurrentPortal = (pathname: string): Portal | null => {
  return PORTALS.find(portal => pathname.startsWith(portal.path)) || null;
};
